"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToVolumeIndicator = subscribeToVolumeIndicator;
var _constants = require("@studio/constants");
var _underscore = require("underscore");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function subscribeToVolumeIndicator(dispatch, setAttendeeMuteStatus, meetingSession, attendeeId, setAttendeeVoiceIntensity) {
  var debouncedCall, attendeeVoiceIntensity;
  var debouncingWindow = 0;
  meetingSession.audioVideo.realtimeSubscribeToVolumeIndicator(attendeeId, function (attendeeId, volume, muted) {
    if (typeof muted === 'boolean' && !!setAttendeeMuteStatus) {
      dispatch(setAttendeeMuteStatus(attendeeId, muted));
    }
    if (!!setAttendeeVoiceIntensity) {
      attendeeVoiceIntensity = volume;
      // Debounce the call to setAttendeeVoiceIntensity to avoid setting the state too frequently
      if (!debouncedCall || attendeeVoiceIntensity > _constants.ACTIVE_SPEAKER_INTENSITY_THRESHOLD) {
        // reset debouncing window if the intensity is above the threshold
        // to show the indicator between natural speech lags
        if (debouncedCall) {
          debouncedCall.cancel();
        }
        debouncedCall = (0, _underscore.debounce)(function () {
          // show indicator immediately but remove it with 1.5 seconds debouncing
          if (attendeeVoiceIntensity > _constants.ACTIVE_SPEAKER_INTENSITY_THRESHOLD) {
            debouncingWindow = 1500;
          } else {
            debouncingWindow = 0;
          }
          dispatch(setAttendeeVoiceIntensity(_defineProperty({}, attendeeId, attendeeVoiceIntensity)));
          debouncedCall = null;
        }, debouncingWindow);
        debouncedCall();
      }
    }
  });
}